import React, {useEffect, useState} from "react";
import {NavLink, useNavigate} from "react-router-dom";
import {useLogoutHandle} from "../../hooks/logoutHandle";
import {useMemberWallet} from "../../hooks/useMemberWallet";
import {useAccountNavigation} from "../../hooks/useAccountNavigation";
import {BalanceArea} from "../../components/bank/BalanceArea";
import {isLoggedIn} from "../../utils/authUtils";

const Menu = () => {
    const navigate = useNavigate();

    const logoutHandle = useLogoutHandle();

    const {memberWalletInfo, loading, error, refetch} = useMemberWallet();
    const handleAccountNavigation = useAccountNavigation(memberWalletInfo?.accountNo);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    useEffect(() => {
        const checkLoginStatus = async () => {
            if (isLoggedIn()) {
                setIsAuthenticated(true);
            } else {
                setIsAuthenticated(false);
            }
        };

        checkLoginStatus();
    }, []);
    const handleLogin = () => {
        navigate('/login');
    };

    const handleSignUp = () => {
        navigate('/signup/terms');
    };

    return (
        <>
            <header className="sub-header">
                <div className="header-inner">
                    <h1 className="subtitle none">전체메뉴</h1>
                </div>
            </header>
            <main className="container type_gray">
                <section className="bg-white">
                        {isAuthenticated ? (
                            <>
                            <div className="inner-top">
                                <h3 className="username">
                                    <strong>{memberWalletInfo?.memberName || '회원'}</strong>
                                    <button
                                        type="button"
                                        className="logout-btn"
                                        onClick={logoutHandle}
                                    >
                                        <i className="fa-solid fa-arrow-right-from-bracket"></i> 로그아웃
                                    </button>
                                </h3>
                                <BalanceArea
                                    className={"main-wallet wallet"}
                                    title={"보유 잔액"}
                                    balance={Number(memberWalletInfo?.prepaidBalance || 0)}
                                    expectedBalance={0}
                                    expectedBalanceShow={false}
                                />
                            </div>
                            </>) : (<section className="tit-box-wrap">
                            <h2 className="headline">로그인을 해주세요</h2>
                            <p className="subtit">간병인 신청부터 일자리 찾기까지<br/>더 많은 서비스를 이용할 수 있습니다.</p>
                            <div className="form-btn mt15">
                                <button type="button" className="line-btn" onClick={handleLogin}>로그인</button>
                                <button type="button" className="submit-btn" onClick={handleSignUp}>회원가입</button>
                            </div>
                        </section>)}

                        <ul className="menu-icon-list">
                            <li>
                                <NavLink to="/wallet/charge">
                                    <div className="menu-ico1"></div>
                                    <h4>충전하기</h4>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/menu/favorite">
                                    <div className="menu-ico4"></div>
                                    <h4>즐겨찾기</h4>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/menu/seniorList">
                                    <div className="menu-ico5"></div>
                                    <h4>어르신 관리</h4>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/nearby/shop">
                                    <div className="menu-ico6"></div>
                                    <h4>내 주변 찾기</h4>
                                </NavLink>
                            </li>
                        </ul>
                </section>

                <section className="bg-white">
                    <div className="inner-box">
                        <h3 className="menu-tit">내 정보</h3>
                        <ul className="menu-grid">
                            <li>
                                <NavLink to="/menu/myInfo">내 정보관리</NavLink>
                            </li>
                            <li>
                                <a onClick={handleAccountNavigation} style={{cursor: 'pointer'}}>계좌관리</a>
                            </li>
                            <li>
                                <NavLink to="/menu/seniorList">어르신 관리</NavLink>
                            </li>
                            <li>
                                <NavLink to="/menu/coordinator">코디 정보 관리</NavLink>
                            </li>
                        </ul>

                        <h3 className="menu-tit">내 지갑</h3>
                        <ul className="menu-grid">
                            <li>
                                <NavLink to="/wallet">내 지갑</NavLink>
                            </li>
                            <li>
                                <NavLink to="/wallet/charge">충전하기</NavLink>
                            </li>
                            <li>
                                <NavLink to="/wallet/refund">잔액환불 신청</NavLink>
                            </li>
                        </ul>

                        <h3 className="menu-tit">정산 내역</h3>
                        <ul className="menu-grid">
                            <li>
                                <NavLink to="/settlement">정산 내역</NavLink>
                            </li>
                            <li>
                                <NavLink to="/settlement/withdrawal">출금 신청</NavLink>
                            </li>
                        </ul>

                        <h3 className="menu-tit">내 공고</h3>
                        <ul className="menu-grid">
                            <li>
                                <NavLink to="/announcement/matching">매칭중</NavLink>
                            </li>
                            <li>
                                <NavLink to="/announcement/ongoing">진행중</NavLink>
                            </li>
                            <li>
                                <NavLink to="/announcement/completed">완료/취소</NavLink>
                            </li>
                        </ul>

                        <h3 className="menu-tit">일감 찾기</h3>
                        <ul className="menu-grid">
                            <li>
                                <NavLink to="/task/findTask">일감찾기</NavLink>
                            </li>
                            <li>
                                <NavLink to="/task/myTask">내 일감</NavLink>
                            </li>
                        </ul>

                        <h3 className="menu-tit">고객센터</h3>
                        <ul className="menu-grid">
                            <li>
                                <NavLink to="/desk/notice">공지사항</NavLink>
                            </li>
                            <li>
                                <NavLink to="/desk/qna">1:1문의</NavLink>
                            </li>
                            <li>
                                <NavLink to="/desk/faq">자주묻는 질문</NavLink>
                            </li>
                            <li>
                                <NavLink to="/terms/termsList">이용약관</NavLink>
                            </li>
                            <li>
                                <NavLink to="/desk/inquiry">제휴문의</NavLink>
                            </li>
                            <li>
                                <NavLink to="/menu/company-info">회사정보</NavLink>
                            </li>
                        </ul>

                        <h3 className="menu-tit">설정</h3>
                        <ul className="menu-grid">
                            <li>
                                <NavLink to="/alarmList">알림내역</NavLink>
                            </li>
                            <li>
                                <NavLink to="/alarmSetting">알림설정</NavLink>
                            </li>
                            <li>
                                <NavLink to="/memberWithdrawal">회원탈퇴</NavLink>
                            </li>
                        </ul>
                    </div>
                </section>
            </main>
        </>
    );
};

export default Menu;
